module.exports = __webpack_public_path__ + "img/gcm.d2eed60a.jpg";